module.exports = __webpack_public_path__ + "static/media/british-embassy.902a6a35.jpg";